/* =========================================================
   Amarin Kaba — JavaScript del tema (sin dependencias)
   ========================================================= */
(function () {
  'use strict';

  var K = window.kaba || { routes: {}, strings: {}, moneyFormat: '${{amount}}' };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Dinero ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || K.moneyFormat || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var m = format.match(re);
    var value = '';
    switch (m && m[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(re, value);
  }
  // Como las tarjetas muestran precios sin decimales, quitamos ",00" / ".00" al final
  function money(cents) {
    return formatMoney(cents).replace(/([.,]00)(?=\D*$)/, '');
  }

  /* ---------- Aviso (toast) ---------- */
  var toastTimer;
  function toast(text, opts) {
    var el = $('[data-k-toast]');
    if (!el) return;
    opts = opts || {};
    $('[data-k-toast-text]', el).textContent = text;
    var link = $('[data-k-toast-link]', el);
    if (link) link.hidden = !!opts.error;
    el.classList.toggle('is-error', !!opts.error);
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 350);
    }, opts.error ? 4500 : 3500);
  }

  /* ---------- Carrito: contador ---------- */
  function setCartCount(n) {
    $$('[data-k-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !(n > 0);
    });
  }
  function refreshCartCount() {
    return fetch(K.routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  function bumpCart() {
    $$('[data-k-cart-count]').forEach(function (el) {
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
    $$('.kh__cart').forEach(function (el) {
      el.classList.remove('is-shake'); void el.offsetWidth; el.classList.add('is-shake');
    });
  }

  function addToCart(form, btn, onDone) {
    var fd = new FormData(form);
    if (btn) btn.classList.add('is-loading');
    return fetch(K.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = res.data.description || res.data.message || K.strings.error;
          toast(msg, { error: true });
          if (onDone) onDone(msg);
          return;
        }
        toast(K.strings.added || 'Agregado al carrito');
        refreshCartCount().then(bumpCart);
        if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1400); }
        if (onDone) onDone();
      })
      .catch(function () {
        toast(K.strings.error || 'No se pudo agregar el producto', { error: true });
        if (onDone) onDone('error');
      })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  /* ---------- Header: mensajes rotativos y menú móvil ---------- */
  function initRotator() {
    $$('[data-k-rotator]').forEach(function (box) {
      var items = $$('.kh__msg', box);
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4500);
    });
  }

  function initDrawer() {
    var drawer = $('[data-k-drawer]');
    if (!drawer) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-k-menu-open]')) {
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
      } else if (e.target.closest('[data-k-menu-close]')) {
        drawer.hidden = true;
        document.body.style.overflow = '';
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) {
        drawer.hidden = true;
        document.body.style.overflow = '';
      }
    });
  }

  /* ---------- Hero (banner principal) ---------- */
  function initHero(root) {
    $$('[data-k-hero]', root).forEach(function (hero) {
      if (hero._kInit) return;
      hero._kInit = true;
      var track = $('[data-k-hero-track]', hero);
      var slides = $$('[data-k-hero-slide]', hero);
      var dots = $$('[data-k-hero-dot]', hero);
      if (slides[0]) slides[0].classList.add('is-active');
      if (!track || slides.length < 2) return;
      var index = 0, timer;
      var auto = hero.getAttribute('data-autoplay') === 'true';
      var interval = (parseFloat(hero.getAttribute('data-interval')) || 6) * 1000;

      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      }
      function start() { if (auto) { stop(); timer = setInterval(function () { go(index + 1); }, interval); } }
      function stop() { clearInterval(timer); }

      var prev = $('[data-k-hero-prev]', hero), next = $('[data-k-hero-next]', hero);
      if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
      if (next) next.addEventListener('click', function () { go(index + 1); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-k-hero-dot'), 10)); start(); });
      });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      var sx = 0, dx = 0, touching = false;
      track.addEventListener('touchstart', function (e) { touching = true; sx = e.touches[0].clientX; dx = 0; stop(); }, { passive: true });
      track.addEventListener('touchmove', function (e) { if (touching) dx = e.touches[0].clientX - sx; }, { passive: true });
      track.addEventListener('touchend', function () {
        touching = false;
        if (Math.abs(dx) > 40) go(dx < 0 ? index + 1 : index - 1);
        start();
      });
      // Editor de temas: mostrar la diapositiva seleccionada
      hero.addEventListener('shopify:block:select', function (e) {
        var n = slides.indexOf(e.target); if (n > -1) { go(n); stop(); }
      });
      go(0); start();
    });
  }

  /* ---------- Carruseles de productos ---------- */
  function initCarousels(root) {
    $$('[data-k-carousel]', root).forEach(function (stage) {
      if (stage._kInit) return;
      stage._kInit = true;
      var track = $('[data-k-carousel-track]', stage);
      var prev = $('[data-k-prev]', stage), next = $('[data-k-next]', stage);
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var scrollable = max > 0;
        [prev, next].forEach(function (b) { if (b) b.style.visibility = scrollable ? '' : 'hidden'; });
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      function step(dir) {
        var slide = $('.kcar__slide', track);
        var w = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        var per = Math.max(1, Math.floor(track.clientWidth / w));
        track.scrollBy({ left: dir * w * per, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      stage._kUpdate = update;
      update();
      setTimeout(update, 400);
    });
  }

  /* ---------- Pestañas ---------- */
  function initTabs(root) {
    $$('[data-k-tabs]', root).forEach(function (wrap) {
      if (wrap._kInit) return;
      wrap._kInit = true;
      var tabs = $$('[data-k-tab]', wrap);
      var panels = $$('[data-k-panel]', wrap);
      function show(id) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-k-tab') === id;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-k-panel') === id;
          p.hidden = !on;
          p.classList.toggle('is-active', on);
          if (on) $$('[data-k-carousel]', p).forEach(function (s) { if (s._kUpdate) s._kUpdate(); });
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-k-tab')); });
      });
      wrap.addEventListener('shopify:block:select', function (e) {
        var id = e.target.getAttribute && e.target.getAttribute('data-k-tab');
        if (id) show(id);
      });
    });
  }

  /* ---------- Tarjetas: agregar al carrito rápido ---------- */
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-k-add-form]');
      if (!form) return;
      e.preventDefault();
      var btn = $('[data-k-add-btn]', form);
      addToCart(form, btn);
    });
  }

  /* ---------- Página de producto ---------- */
  function initProduct(root) {
    $$('[data-k-product]', root).forEach(function (sec) {
      if (sec._kInit) return;
      sec._kInit = true;

      var variants = [];
      try { variants = JSON.parse($('[data-k-variants]', sec).textContent); } catch (err) {}
      var form = $('[data-k-product-form]', sec);
      var idInput = $('[data-k-variant-id]', sec);
      var priceBox = $('[data-k-price]', sec);
      var nowEl = $('[data-k-now]', sec), compareEl = $('[data-k-compare]', sec), saveEl = $('[data-k-save]', sec);
      var submit = $('[data-k-submit]', sec), submitText = $('[data-k-submit-text]', sec);
      var msg = $('[data-k-msg]', sec);
      var optionInputs = $$('[data-k-option]', sec);

      /* Galería */
      var slidesEl = $('[data-k-slides]', sec);
      var slideEls = slidesEl ? $$('.kpdp__slide', slidesEl) : [];
      var thumbs = $$('[data-k-thumb]', sec);
      function goSlide(i) {
        if (!slidesEl || !slideEls[i]) return;
        slidesEl.scrollTo({ left: slideEls[i].offsetLeft - slidesEl.offsetLeft, behavior: 'smooth' });
      }
      function currentSlide() {
        if (!slidesEl) return 0;
        return Math.round(slidesEl.scrollLeft / (slidesEl.clientWidth || 1));
      }
      function markThumb(i) { thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); }); }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goSlide(parseInt(t.getAttribute('data-k-thumb'), 10)); });
      });
      var pv = $('[data-k-slide-prev]', sec), nx = $('[data-k-slide-next]', sec);
      if (pv) pv.addEventListener('click', function () { goSlide(Math.max(0, currentSlide() - 1)); });
      if (nx) nx.addEventListener('click', function () { goSlide(Math.min(slideEls.length - 1, currentSlide() + 1)); });
      if (slidesEl) slidesEl.addEventListener('scroll', function () { window.requestAnimationFrame(function () { markThumb(currentSlide()); }); }, { passive: true });

      /* Variantes */
      function selectedOptions() {
        var opts = [];
        optionInputs.forEach(function (inp) { if (inp.checked) opts[parseInt(inp.getAttribute('data-k-option'), 10)] = inp.value; });
        return opts;
      }
      function findVariant() {
        var opts = selectedOptions();
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < opts.length; j++) { if (opts[j] !== undefined && v.options[j] !== opts[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function renderVariant(v) {
        if (!v) {
          if (submit) { submit.disabled = true; }
          if (submitText) submitText.textContent = K.strings.unavailable || 'No disponible';
          return;
        }
        if (idInput) idInput.value = v.id;
        if (nowEl) nowEl.textContent = money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = money(v.compare_at_price); }
        if (priceBox) priceBox.classList.toggle('is-sale', !!onSale);
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) saveEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF';
        }
        if (submit) submit.disabled = !v.available;
        if (submitText) submitText.textContent = v.available ? (K.strings.add || 'Agregar al carrito').toUpperCase() : (K.strings.soldOut || 'Agotado').toUpperCase();
        if (msg) msg.hidden = true;
        // URL
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        // Imagen de la variante
        var mid = v.featured_media && v.featured_media.id;
        if (mid) {
          for (var s = 0; s < slideEls.length; s++) {
            if (String(slideEls[s].getAttribute('data-media-id')) === String(mid)) { goSlide(s); break; }
          }
        }
      }
      optionInputs.forEach(function (inp) {
        inp.addEventListener('change', function () { renderVariant(findVariant()); });
      });

      /* Cantidad */
      var qty = $('[data-k-qty]', sec);
      var minus = $('[data-k-qty-minus]', sec), plus = $('[data-k-qty-plus]', sec);
      if (qty) {
        if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
        if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
        qty.addEventListener('change', function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });
      }

      /* Envío AJAX */
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (submit && submit.disabled) return;
          if (msg) msg.hidden = true;
          addToCart(form, submit, function (err) {
            if (err && msg) { msg.textContent = err; msg.hidden = false; }
          });
        });
      }
    });
  }

  /* ---------- Productos relacionados (recomendaciones) ---------- */
  function initRelated(root) {
    $$('[data-k-related]', root).forEach(function (sec) {
      if (sec._kInit) return;
      sec._kInit = true;
      var url = sec.getAttribute('data-url');
      if (!url || $('.kcar__slide', sec)) { initCarousels(sec); return; }
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-k-related]');
          if (fresh && fresh.querySelector('.kcar__slide')) {
            sec.innerHTML = fresh.innerHTML;
            sec.hidden = false;
            sec._kInit = false;
            initCarousels(sec);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Colección: filtros y orden ---------- */
  function initFilters() {
    var form = $('[data-k-filters]');
    if (!form) return;
    var panel = $('[data-k-filter-panel]');
    var overlay = $('.kcol__overlay');

    function open() {
      if (!panel) return;
      panel.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (!panel) return;
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-k-filter-open]')) open();
      else if (e.target.closest('[data-k-filter-close]')) close();
    });

    var timer;
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el.form || el.form !== form) return;
      // En escritorio se aplica al instante; en móvil se aplica con el botón "Aplicar" (salvo el orden)
      var isSort = el.hasAttribute('data-k-sort');
      var isMobile = window.matchMedia('(max-width: 989px)').matches;
      if (isMobile && !isSort) return;
      clearTimeout(timer);
      timer = setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, isSort ? 0 : 250);
    });
    form.addEventListener('submit', function () {
      $$('[form="' + form.id + '"]').forEach(function (el) {
        if (el.type === 'number' && el.value === '') el.disabled = true;
      });
    });
  }

  /* ---------- Página de carrito ---------- */
  function initCartPage() {
    var form = $('[data-k-cart-form]');
    if (!form) return;
    var timer;
    function submitSoon() {
      clearTimeout(timer);
      timer = setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, 500);
    }
    form.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-k-cart-minus]');
      var plus = e.target.closest('[data-k-cart-plus]');
      if (!minus && !plus) return;
      var input = $('[data-k-cart-qty]', (minus || plus).parentNode);
      var v = parseInt(input.value, 10) || 0;
      input.value = Math.max(0, v + (plus ? 1 : -1));
      submitSoon();
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-k-cart-qty]')) { e.target.value = Math.max(0, parseInt(e.target.value, 10) || 0); submitSoon(); }
    });
  }

  /* ---------- Header fijo que se compacta ---------- */
  function initHeader() {
    var h = $('.kh');
    if (!h) return;
    var stuck = false, ticking = false;
    function check() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (!stuck && y > 90) { stuck = true; h.classList.add('is-stuck'); }
      else if (stuck && y < 20) { stuck = false; h.classList.remove('is-stuck'); }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
    }, { passive: true });
    check();
  }

  /* ---------- Barra de progreso de lectura ---------- */
  function initProgress() {
    if (!K.progress || $('.k-progress')) return;
    var wrap = document.createElement('div');
    wrap.className = 'k-progress';
    wrap.innerHTML = '<div class="k-progress__bar"></div>';
    document.body.appendChild(wrap);
    var bar = wrap.firstChild, ticking = false;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? (window.pageYOffset || document.documentElement.scrollTop) / h : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)) + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Aparecer al bajar ---------- */
  var REVEAL = '.ksc__head, .ksc__item, .kcat__head, .kcat__item, .kcar__head, .ktabs__head, .kcar__cta, .kbn__panel, .ktr__item, .kts__title, .kts__card, .knl__card, .kf__brand, .kf__col, .kblog__card, .klist__item, .kcol__head, .kcol__cell, .kcart__item, .kcart__summary, .kpage__title, .kpage__content, .ksearch, .kform, .kpdp__crumbs';
  var io;
  function initReveal(root) {
    if (!document.documentElement.classList.contains('k-anim')) return;
    root = root || document;
    var list = $$(REVEAL, root);
    // carruseles fuera de pestañas: entran como bloque; las tarjetas escalonadas
    $$('.kcar__stage', root).forEach(function (st) { if (!st.closest('.ktabs__panel')) list.push(st); });
    $$('.kcar__track', root).forEach(function (tr) {
      $$('.kcar__slide', tr).forEach(function (sl, i) { sl.style.setProperty('--i', Math.min(i, 8)); });
    });
    if (!('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var t = en.target;
            t.classList.add('is-in'); io.unobserve(t);
            // al terminar, se limpia para que el hover vuelva a ser inmediato
            setTimeout(function () {
              t.style.transitionDelay = '';
              t.classList.remove('k-reveal', 'is-in', 'k-reveal--zoom', 'k-reveal--left', 'k-reveal--right');
            }, 2000);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    var groups = new Map();
    list.forEach(function (el) {
      if (el._kRev) return;
      el._kRev = true;
      var parent = el.parentNode;
      var idx = groups.get(parent) || 0; groups.set(parent, idx + 1);
      el.style.setProperty('--i', Math.min(idx, 8));
      if (!el.classList.contains('kcar__stage')) el.style.transitionDelay = (Math.min(idx, 8) * 70) + 'ms';
      el.classList.add('k-reveal');
      if (el.matches('.kts__card, .kbn__panel')) el.classList.add('k-reveal--zoom');
      if (el.matches('.kf__brand')) el.classList.add('k-reveal--left');
      io.observe(el);
    });
  }

  /* ---------- Categorías en círculos: carrusel hacia la derecha ---------- */
  function initCats(root) {
    $$('[data-k-cat]', root).forEach(function (sec) {
      if (sec._kInit) return;
      sec._kInit = true;
      var track = $('[data-k-cat-track]', sec);
      if (!track) return;
      var prev = $('[data-k-cat-prev]', sec), next = $('[data-k-cat-next]', sec);
      var timer = null, paused = false;
      var auto = sec.getAttribute('data-autoplay') === 'true';
      var secs = Math.max(2, parseInt(sec.getAttribute('data-interval'), 10) || 3);
      function stepW() {
        var it = $('.kcat__item', track);
        if (!it) return track.clientWidth * 0.8;
        var cs = window.getComputedStyle(track);
        return it.getBoundingClientRect().width + (parseFloat(cs.columnGap || cs.gap) || 0);
      }
      function go(dir) {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (max <= 0) return;
        if (dir > 0 && track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: max, behavior: 'smooth' }); return; }
        track.scrollBy({ left: dir * stepW(), behavior: 'smooth' });
      }
      function start() {
        stop();
        if (!auto || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = setInterval(function () { if (!paused && !document.hidden) go(1); }, secs * 1000);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      if (prev) prev.addEventListener('click', function () { go(-1); start(); });
      if (next) next.addEventListener('click', function () { go(1); start(); });
      sec.addEventListener('mouseenter', function () { paused = true; });
      sec.addEventListener('mouseleave', function () { paused = false; });
      sec.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      sec.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true });
      start();
    });
  }

  /* ---------- Arranque ---------- */
  function initAll(root) {
    initHero(root);
    initCarousels(root);
    initCats(root);
    initTabs(root);
    initProduct(root);
    initRelated(root);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initRotator();
    initDrawer();
    initQuickAdd();
    initFilters();
    initCartPage();
    initHeader();
    initProgress();
    initAll(document);
    initReveal(document);
  });

  // Editor de temas: reiniciar la sección que se recarga
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initReveal(e.target); });
})();
